export { default as ClauseSection } from './clause-section/clause-section'
export { default as CookiePolicySection } from './cookie-policy-section/cookie-policy-section'
export { TableSection } from './table-section/table-section'
export { DeleteCookiesSection } from './delete-cookies-section/delete-cookies-section'
